import React from 'react';
import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { Card, Typography, Grid, units } from '@ha/dsl';
import { useIntl } from 'ha/i18n';

import { getIsAdmin, getIsAdvertiser } from 'ha/modules/AuthLogic/selectors';
import { SearchAlert } from '../SearchAlerts/SearchAlert';
import SearchFilters from './SearchFilters';

const useStyles = makeStyles(() => ({
  card: {
    paddingTop: 0,
    paddingBottom: 0,
    // to not crop price filter slider labels
    overflow: 'initial',
  },
  titleWrapper: {
    padding: units.yx(1, 1.5),
  },
  header: {
    fontSize: units.rem(1.125),
  },
}));

const SearchFiltersSidebar: React.FC = () => {
  const { T } = useIntl();
  const classes = useStyles();

  const isAdvertiser = useSelector(getIsAdvertiser);
  const isAdmin = useSelector(getIsAdmin);

  return (
    <Card
      className={classes.card}
      variant="outlined"
      data-test-locator="Search Filters Sidebar"
    >
      <Grid
        container
        className={classes.titleWrapper}
        justify="space-between"
        alignItems="center"
      >
        <Grid item>
          <Typography.H2 className={classes.header}>
            {T('Filters')}
          </Typography.H2>
        </Grid>
        {(!isAdvertiser || isAdmin) && (
          <Grid item>
            <SearchAlert size="large" variant="link" fullWidth />
          </Grid>
        )}
      </Grid>
      <SearchFilters withDateFilter />
    </Card>
  );
};

export default SearchFiltersSidebar;
